
export class CostCentersDto {
  costCenterId?: number;
  costCenterCode:string;
  costCenterName: string;
  status: boolean;
  createdAt : Date | any;
  createdUser : number;
  updatedAt : Date | any;
  updatedUser : number;
  versionFlag : number;
}
export const CostCenterDtoDefault : CostCentersDto = {
  costCenterId: 0,
  costCenterCode:"",
  costCenterName: "",
  status: true,
  createdAt : new Date() ,
  createdUser : 0,
  updatedAt : new Date() ,
  updatedUser : 0,
  versionFlag : 1
};